import React from 'react'
import { useStateContext } from '../../context/ContextProvider'
import { useTranslation } from 'react-i18next'

const SecondaryButton = ({text, icon, textSize, onClick,pulse,id,ref ,className}) => {
  const {t} = useTranslation()
  const {currentMode} = useStateContext()
  
  return (
    <button id={id} ref={ref}
      className={`creative-secondary-btn ${className ? className :"px-[1.5rem] rounded-2xl py-[0.75rem]"} ${currentMode === "Light" ?"creative-light ": "creative-dark"}     ${pulse ? "pulse" : ""}`}
      onClick={onClick}
    >
      <span className={`creative-btn-text dark:text-dark-link  font-kufi ${textSize}`}>{t(text)}</span>
      {icon && <span className='creative-btn-icon dark:text-dark-link '>{icon}</span>}
    </button>
  )
}


export default SecondaryButton